// Marathi & English translations for वनाझ परिवार शिक्षण मंडळ

export const translations = {
  mr: {
    // Common
    schoolName: "वनाझ परिवार विद्या मंदिर",
    schoolOrg: "वनाझ परिवार शिक्षण मंडळ",
    schoolTagline: "कोथरूड, पुणे — स्थापना १९७८",
    vision: "विद्यार्थ्यांचा सर्वांगीण विकास... हाच आमचा ध्यास..!",
    
    // Navigation
    nav: {
      home: "मुख्यपृष्ठ",
      about: "आमच्या बद्दल",
      facilities: "सुविधा",
      activities: "उपक्रम",
      gallery: "गॅलरी",
      achievements: "विद्यार्थ्यांचे यश",
      contact: "संपर्क",
      enquire: "प्रवेशासाठी चौकशी",
    },

    // Hero
    hero: {
      eyebrow: "बालवाडी ते १० वी | मराठी माध्यम | स्थापना १९७८",
      headlineA: "तुमच्या मुलाचे",
      headlineB: "उज्ज्वल भविष्य",
      headlineC: "आमच्या विश्वासाने",
      sub: "गेली अनेक वर्षे कोथरूडमधील हजारो पालकांचा विश्वास कमावणारी शाळा. दर्जेदार शिक्षण, संस्कार आणि सर्वांगीण विकासाचा भक्कम पाया.",
      ctaPrimary: "प्रवेशासाठी चौकशी करा",
      ctaSecondary: "शाळेला भेट द्या",
      statYears: "वर्षांचा वारसा",
      statStudents: "आजी-माजी विद्यार्थी",
      statResult: "१० वी निकाल",
    },

    // Trust Pillars
    trust: {
      eyebrow: "आमचे बलस्थान",
      title: "पालकांचा विश्वास का?",
      sub: "प्रत्येक पालकाला हवे असणारे गुण आमच्या शाळेचा पाया आहेत.",
      items: [
        { title: "अनुभवी शिक्षक", desc: "प्रशिक्षित, समर्पित आणि विद्यार्थ्यांची मनोवृत्ती जाणणारे शिक्षक." },
        { title: "सुरक्षित परिसर", desc: "CCTV निगराणी, प्रशिक्षित सुरक्षारक्षक आणि सुरक्षित वाहतूक व्यवस्था." },
        { title: "उत्कृष्ट निकाल", desc: "१० वी बोर्ड परीक्षेत सातत्याने उत्कृष्ट कामगिरी; अनेक गुणवत्ताधारक विद्यार्थी." },
        { title: "संस्कार व शिस्त", desc: "मराठी संस्कृतीची जोपासना, चारित्र्यनिर्माण आणि जीवनमूल्यांची शिकवण." },
        { title: "सर्वांगीण विकास", desc: "शैक्षणिक, क्रीडा, कला, नेतृत्व — प्रत्येक पैलूवर विशेष लक्ष." },
      ],
    },

    // About Preview
    aboutPrev: {
      eyebrow: "आमच्या बद्दल",
      title: "ज्ञान, संस्कार आणि आनंदाचे शिक्षणमंदिर",
      p1: "वनाझ परिवार विद्या मंदिर ही कोथरूड, पुणे येथील १९७८ साली स्थापन झालेली एक सुप्रसिद्ध आणि विश्वासार्ह शैक्षणिक संस्था आहे. बालवाडी पासून इयत्ता १० वी पर्यंत मराठी माध्यमात आम्ही दर्जेदार शिक्षण देतो.",
      p2: "शैक्षणिक गुणवत्ता, पारंपरिक मूल्ये आणि आधुनिक दृष्टिकोनाचा सुंदर संगम हेच आमच्या शाळेचे वैशिष्ट्य. प्रत्येक मूल हे अद्वितीय आहे — त्याच्यातील गुणांना वाव देणे हेच आमचे ध्येय.",
      readMore: "अधिक वाचा",
    },

    // Facilities preview
    facPrev: {
      eyebrow: "आमच्या सुविधा",
      title: "शिकण्यासाठी पोषक वातावरण",
      sub: "आधुनिक सुविधा आणि सुरक्षित परिसर — अभ्यासासोबतच आनंददायी अनुभव.",
      items: [
        { title: "स्मार्ट वर्गखोल्या", desc: "डिजिटल बोर्ड व प्रोजेक्टरसह सुसज्ज." },
        { title: "समृद्ध ग्रंथालय", desc: "मराठी व इंग्रजी पुस्तकांचा विस्तृत संग्रह." },
        { title: "संगणक प्रयोगशाळा", desc: "अद्ययावत संगणक आणि इंटरनेट सुविधा." },
        { title: "विस्तीर्ण क्रीडांगण", desc: "सुरक्षित, मोकळे आणि खेळासाठी पुरेसे मैदान." },
        { title: "सुरक्षा व्यवस्था", desc: "CCTV, प्रशिक्षित सुरक्षारक्षक, सुरक्षित प्रवेशद्वार." },
        { title: "स्वच्छता व आरोग्य", desc: "स्वच्छ पिण्याचे पाणी व स्वच्छ प्रसाधनगृहे." },
      ],
    },

    // Activities preview
    actPrev: {
      eyebrow: "आमचे उपक्रम",
      title: "शिक्षणाच्या पलीकडले अनुभव",
      sub: "क्रीडा, कला, सांस्कृतिक आणि नेतृत्वगुणांना वाव देणारे वैविध्यपूर्ण उपक्रम.",
      items: [
        { title: "क्रीडा स्पर्धा", desc: "जिल्हा व राज्यस्तरीय स्पर्धांमध्ये सहभाग." },
        { title: "सांस्कृतिक कार्यक्रम", desc: "गणेशोत्सव, स्नेहसंमेलन, वार्षिक स्नेहभोजन." },
        { title: "वैज्ञानिक प्रकल्प", desc: "विज्ञान प्रदर्शन, नाविन्यपूर्ण प्रयोग." },
        { title: "नेतृत्व विकास", desc: "विद्यार्थी परिषद, स्काऊट-गाईड, NCC." },
      ],
    },

    // Achievements preview
    achPrev: {
      eyebrow: "विद्यार्थ्यांचे यश",
      title: "प्रत्येक वर्षी उत्कृष्टतेचा ठसा",
      sub: "आमच्या विद्यार्थ्यांनी बोर्ड परीक्षा, क्रीडा आणि कला क्षेत्रात सातत्याने यश मिळवले आहे.",
      stats: [
        { num: "९१%", label: "१० वी टॉपर (२०२६)" },
        { num: "१५+", label: "गुणवत्ताधारक विद्यार्थी" },
        { num: "७+", label: "पुरस्कार व मान्यता" },
        { num: "४६+", label: "वर्षांचा शैक्षणिक वारसा" },
      ],
      toppers: [
        { name: "कु. स्वरा अरुण ढमाले", marks: "९१.००%", note: "प्रथम क्रमांक — २०२६" },
        { name: "कु. खुशी नवनाथ तिडके", marks: "९०.६०%", note: "द्वितीय क्रमांक — २०२६" },
        { name: "कु. श्रेया समीर रावडे", marks: "८९.००%", note: "तृतीय क्रमांक — २०२६" },
      ],
    },

    // Testimonials
    testimonials: {
      eyebrow: "पालकांचा अभिप्राय",
      title: "पालकांच्या शब्दांत",
      list: [
        { quote: "माझ्या मुलीच्या जीवनात या शाळेने खूप मोठा बदल घडवला. इथले शिक्षक मुलांना केवळ शिक्षण नाही तर संस्कारही देतात.", author: "सोनल गायकवाड", role: "पालक — इयत्ता ८ वी" },
        { quote: "मुलांसाठी सुरक्षित, शिस्तबद्ध आणि आनंददायी वातावरण. शिक्षकांचे वैयक्तिक लक्ष ही आमच्यासाठी सर्वात मोठी जमेची बाजू.", author: "संतोष सातपुते", role: "पालक — इयत्ता १० वी" },
        { quote: "वनाझ परिवार शाळेत आमचा मुलगा शिकतो हे आम्हाला अभिमानास्पद वाटते. दर्जेदार शिक्षण आणि वाजवी फी.", author: "सोनाली ओसवाल", role: "पालक — इयत्ता ५ वी" },
      ],
    },

    // Enquiry Form
    enquiry: {
      eyebrow: "प्रवेशप्रक्रिया",
      title: "तुमच्या मुलाच्या उज्ज्वल भविष्याची सुरुवात इथूनच",
      sub: "खालील माहिती भरा — आम्ही WhatsApp वर लगेच संपर्क साधू.",
      parentName: "पालकाचे नाव",
      mobile: "मोबाईल क्रमांक",
      studentName: "विद्यार्थ्याचे नाव",
      standard: "इयत्ता",
      selectStd: "इयत्ता निवडा",
      submit: "WhatsApp वर पाठवा",
      success: "धन्यवाद! आपण WhatsApp वर पुनर्निर्देशित केले जात आहात...",
      validation: "कृपया सर्व माहिती भरा",
    },

    // FAQ
    faq: {
      eyebrow: "सामान्य प्रश्न",
      title: "पालकांचे बहुचर्चित प्रश्न",
      items: [
        { q: "शाळेची फी किती आहे?", a: "आमची फी इतर शाळांच्या तुलनेत वाजवी आहे. तपशीलवार माहितीसाठी कृपया शाळेत भेट द्या किंवा आम्हाला कॉल करा." },
        { q: "प्रवेश कधी सुरू होतात?", a: "दरवर्षी जानेवारी-फेब्रुवारी मध्ये प्रवेश प्रक्रिया सुरू होते. आजच आमच्याशी संपर्क साधा." },
        { q: "कोणत्या माध्यमातून शिक्षण दिले जाते?", a: "बालवाडी ते इयत्ता १० वी पर्यंत मराठी माध्यमात शिक्षण उपलब्ध आहे." },
        { q: "शाळेच्या वेळा काय आहेत?", a: "सकाळ सत्र: ७:३० ते १२:३० | दुपार सत्र: १२:३० ते ५:३०. शनिवारी अर्धा दिवस." },
        { q: "शाळेत वाहतुकीची सोय आहे का?", a: "हो, कोथरूड व आसपासच्या भागांसाठी सुरक्षित स्कूल बस सेवा उपलब्ध आहे." },
      ],
    },

    // Footer
    footer: {
      about: "कोथरूड, पुणे येथील विश्वासार्ह शाळा — शैक्षणिक गुणवत्ता, संस्कार आणि सर्वांगीण विकासाचे केंद्र.",
      quickLinks: "उपयुक्त दुवे",
      contact: "संपर्क",
      followUs: "आम्हाला फॉलो करा",
      rights: "सर्व हक्क राखीव",
      downloadBrochure: "माहितीपत्रक डाउनलोड करा",
    },

    // Contact Page
    contactPg: {
      eyebrow: "आमच्याशी संपर्क साधा",
      title: "आम्ही तुमच्या प्रश्नांचे स्वागत करतो",
      sub: "भेट द्या, कॉल करा किंवा WhatsApp वर संदेश पाठवा — आम्ही लगेच उत्तर देऊ.",
      address: "पत्ता",
      addressVal: "वनाझ परिवार शिक्षण मंडळ, कोथरूड, पुणे - ४११०३८, महाराष्ट्र",
      phone: "फोन",
      email: "ईमेल",
      hours: "कार्यालयीन वेळ",
      hoursVal: "सोमवार ते शनिवार: सकाळी ८:०० ते संध्याकाळी ५:००",
      getDirections: "मार्ग पहा",
      whatsappNow: "WhatsApp वर संदेश पाठवा",
    },

    // About Page
    aboutPg: {
      title: "आमच्या बद्दल",
      schoolInfo: {
        title: "शाळेची माहिती",
        items: [
          { label: "संस्था", value: "वनाझ परिवार शिक्षण मंडळ" },
          { label: "शाळेचे नाव", value: "वनाझ परिवार विद्या मंदिर" },
          { label: "पत्ता", value: "८५/१, पौड रोड, वनाझ कॉलनी, कोथरूड, पुणे – ३८" },
          { label: "स्थापना वर्ष", value: "१९७८" },
          { label: "संस्थापक", value: "मा. कै. एस. के. खांडेकर साहेब" },
          { label: "शाळा मान्यता क्रमांक", value: "व्ही.एल.एस. १०८७/३२६१ प्रा.शि." },
          { label: "शाळेचा प्रकार", value: "मान्यताप्राप्त खाजगी अनुदानित शाळा" },
          { label: "युडायस क्रमांक", value: "२७२५१४०१३०२" },
        ],
      },
      academic: {
        title: "शैक्षणिक रचना",
        sub: "बालवाडी पासून दहावी पर्यंत — सुसंगत आणि विद्यार्थीकेंद्री अभ्यासक्रम.",
        divisions: [
          {
            title: "बालवाडी विभाग",
            items: ["खेळगट", "शिशुगट", "बालगट"],
          },
          {
            title: "प्राथमिक विभाग",
            items: ["इयत्ता पहिली ते पाचवी", "इयत्ता सहावी ते आठवी"],
          },
          {
            title: "माध्यमिक विभाग",
            items: ["इयत्ता नववी", "इयत्ता दहावी"],
          },
        ],
      },
      history: {
        title: "आमचा वारसा",
        p1: "वनाझ परिवार विद्या मंदिराची स्थापना १९७८ साली मा. कै. एस. के. खांडेकर साहेब यांच्या कल्पकतेतून कोथरूड, पुणे येथे झाली. तेव्हापासून आजपर्यंत आम्ही हजारो विद्यार्थ्यांना दर्जेदार शिक्षण देत आलो आहोत.",
        p2: "शहरी आणि उपनगरीय, सर्व पार्श्वभूमीतून येणाऱ्या मुलांना समान संधी देणे हाच आमचा मूलमंत्र. पारंपरिक मराठी संस्कृती आणि आधुनिक शिक्षण पद्धतीचा सुवर्णमध्य म्हणजे आमची शाळा.",
      },
      mission: {
        title: "आमचे ध्येय",
        text: "प्रत्येक विद्यार्थ्याला शैक्षणिक गुणवत्तेसोबत चारित्र्य, आत्मविश्वास आणि सामाजिक जबाबदारीची जाणीव देऊन एक चांगला माणूस घडवणे.",
      },
      visionCard: {
        title: "आमची दृष्टी",
        text: "ज्ञान, संस्कार आणि आनंदाच्या मिलाफातून विद्यार्थ्यांचा सर्वांगीण विकास करणे आणि त्यांना २१ व्या शतकासाठी सज्ज करणे.",
      },
      values: {
        title: "आमची मूल्ये",
        items: ["सत्य व प्रामाणिकता", "शिस्त व आदर", "परिश्रम व चिकाटी", "सहकार्य व सेवा", "नम्रता व कृतज्ञता"],
      },
      leadership: {
        title: "संचालक मंडळ",
        sub: "अनुभवी, समर्पित आणि शिक्षणाप्रती उत्कट नेतृत्व.",
        members: [
          // { name: "मा. कै. एस. के. खांडेकर साहेब", role: "संस्थापक" },
          { name: "मा. श्री. नितिन कुलकर्णी", role: "अध्यक्ष" },
          { name: "मा. श्रीमती. रजनीताई दाते", role: "उपाध्यक्ष" },
          { name: "मा. श्री. वाय. के. कदम", role: "सचिव" },
          { name: "मा. श्री. विनोद सकपाळ", role: "खजिनदार" },
          { name: "मा. श्री. अ. ल. देशमुख", role: "सदस्य" },
          { name: "मा. श्री. पी. आर. कुलकर्णी", role: "सदस्य" },
          { name: "मा. श्री. एस. जे. विसपुते", role: "सदस्य" },
          { name: "मा. श्री. अजय मोहोळ", role: "सल्लागार" },
        ],
      },
      principals: {
        title: "आमचे मुख्याध्यापक",
        sub: "तीन विभागांचे नेतृत्व — समर्पित आणि अनुभवी.",
        list: [
          {
            name: "सौ. शीतल प्रशांत देशमुख",
            role: "मुख्याध्यापिका",
            qual: "एम.ए. मराठी, बालवाडी कोर्स",
            dept: "पूर्व प्राथमिक विभाग",
          },
          {
            name: "सौ. अनिता सूर्यकांत दारवटकर",
            role: "मुख्याध्यापिका",
            qual: "बी.ए., डी.एड.",
            dept: "प्राथमिक विभाग",
          },
          {
            name: "सौ. वृषाली भूषण वाशीमकर",
            role: "मुख्याध्यापिका",
            qual: "एम.ए., बी.एड., डी.एस.एम.",
            dept: "माध्यमिक विभाग",
          },
        ],
      },
    },

    // Facilities Page
    facilitiesPg: {
      title: "आमच्या सुविधा",
      sub: "आधुनिक आणि सुरक्षित परिसर — शिकण्यासाठी परिपूर्ण वातावरण.",
      list: [
        { title: "स्मार्ट वर्गखोल्या", desc: "डिजिटल बोर्ड, प्रोजेक्टर, आरामदायक बसण्याची व्यवस्था आणि हवेशीर खोल्या. आधुनिक तंत्रज्ञानाच्या मदतीने पारंपरिक शिक्षण अधिक रंजक." },
        { title: "ग्रंथालय", desc: "५,००० हून अधिक मराठी व इंग्रजी पुस्तकांचा संग्रह. संदर्भ ग्रंथ, कथा, विज्ञान, चरित्र आणि स्पर्धा परीक्षांसाठी उपयुक्त साहित्य." },
        { title: "संगणक प्रयोगशाळा", desc: "३० अद्ययावत संगणकांची सुसज्ज प्रयोगशाळा, हायस्पीड इंटरनेट आणि प्रशिक्षित संगणक शिक्षक." },
        { title: "विज्ञान प्रयोगशाळा", desc: "भौतिकशास्त्र, रसायनशास्त्र व जीवशास्त्रासाठी स्वतंत्र प्रयोगशाळा. प्रत्यक्ष प्रयोगांतून संकल्पना स्पष्ट होतात." },
        { title: "विस्तीर्ण क्रीडांगण", desc: "क्रिकेट, खो-खो, कबड्डी, बॅडमिंटन, व्हॉलीबॉल — सर्व क्रीडाप्रकारांसाठी पुरेसे व सुरक्षित मैदान." },
        { title: "CCTV सुरक्षा व्यवस्था", desc: "२४ तास CCTV निगराणी, प्रशिक्षित सुरक्षारक्षक, सुरक्षित प्रवेशद्वार आणि अभ्यागत नोंदणी." },
        { title: "वैद्यकीय कक्ष", desc: "प्रथमोपचार साहित्य व नोंदणीकृत वैद्यकीय सहाय्य. आपत्कालीन परिस्थितीत तत्काळ मदत." },
        { title: "पिण्याचे शुद्ध पाणी", desc: "RO + UV शुद्धीकरण केलेले पाणी, स्वच्छ टंकीची नियमित साफसफाई." },
        { title: "स्वच्छ प्रसाधनगृहे", desc: "मुलां-मुलींसाठी स्वतंत्र, स्वच्छ आणि आरोग्यदायी प्रसाधनगृहे." },
      ],
    },

    // Activities Page
    activitiesPg: {
      title: "आमचे उपक्रम",
      sub: "शिक्षणाच्या पलीकडे जाऊन विद्यार्थ्यांच्या संपूर्ण व्यक्तिमत्त्वाचा विकास.",
      categories: [
        {
          title: "क्रीडा विभाग",
          items: ["आंतरशालेय क्रिकेट, खो-खो, कबड्डी स्पर्धा", "योगा व सूर्यनमस्कार दररोज", "वार्षिक क्रीडा महोत्सव", "जिल्हा व राज्यस्तरीय सहभाग"],
        },
        {
          title: "सांस्कृतिक कार्यक्रम",
          items: ["गणेशोत्सव, गुढीपाडवा, स्वातंत्र्यदिन विशेष कार्यक्रम", "नाट्य, नृत्य, गायन स्पर्धा", "स्नेहसंमेलन व वार्षिक पारितोषिक वितरण", "मराठी भाषा संवर्धन उपक्रम"],
        },
        {
          title: "शैक्षणिक स्पर्धा",
          items: ["विज्ञान प्रदर्शन व नाविन्यपूर्ण प्रकल्प", "निबंध, वक्तृत्व, हस्ताक्षर स्पर्धा", "गणित ऑलिम्पियाड व स्कॉलरशिप तयारी", "MTSE, NTSE सहभाग व मार्गदर्शन"],
        },
        {
          title: "सामाजिक उपक्रम",
          items: ["वृक्षारोपण व पर्यावरण जनजागृती", "स्वच्छता अभियान", "वृद्धाश्रम व अनाथाश्रम भेटी", "रक्तदान शिबिर सहभाग"],
        },
        {
          title: "चारित्र्य निर्माण",
          items: ["नैतिक शिक्षण तासिका", "नेतृत्व विकास कार्यशाळा", "ध्यान व संवाद सत्र", "ज्येष्ठांचे मार्गदर्शन"],
        },
      ],
    },

    // Gallery Page
    galleryPg: {
      title: "गॅलरी",
      sub: "आमच्या शाळेच्या वैविध्यपूर्ण उपक्रमांची आणि विद्यार्थ्यांच्या चैतन्यमय जीवनाची झलक.",
      filterAll: "सर्व",
      categories: [
        { key: "purv", title: "पूर्व प्राथमिक", caption: "बालवाडी विभागातील इवल्याशा हातांची किलबिल — खेळ, गाणी आणि शिकण्याचा आनंद." },
        { key: "prathmik", title: "प्राथमिक", caption: "इयत्ता पहिली ते आठवीच्या विद्यार्थ्यांच्या शैक्षणिक व इतर उपक्रमांची झलक." },
        { key: "madhyamik", title: "माध्यमिक", caption: "इयत्ता नववी व दहावीच्या विद्यार्थ्यांच्या स्पर्धा, उपक्रम व यशोगाथा." },
      ],
    },

    // Achievements Page
    achievementsPg: {
      title: "विद्यार्थ्यांचे यश",
      sub: "ज्ञान, गुणवत्ता आणि सलग १००% निकालाची १० वर्षांची गाथा!",
      toppers: {
        title: "आमचे अभिमान — गुणवत्ताधारक",
        sub: "इयत्ता १० वी बोर्ड परीक्षेत चमकलेले आमचे विद्यार्थी.",
        years: [
          {
            year: "२०२६",
            list: [
              { name: "कु. स्वरा अरुण ढमाले", marks: "९१.००%", rank: "प्रथम क्रमांक" },
              { name: "कु. खुशी नवनाथ तिडके", marks: "९०.६०%", rank: "द्वितीय क्रमांक" },
              { name: "कु. श्रेया समीर रावडे", marks: "८९.००%", rank: "तृतीय क्रमांक" },
            ],
          },
          {
            year: "२०२५",
            list: [
              { name: "कु. अनुष्का समीर रावडे", marks: "९१.४०%", rank: "" },
              { name: "कु. ओम संग्राम मुळे", marks: "९०.८०%", rank: "" },
              { name: "कु. भक्ती दत्ता शिंदे", marks: "९०.२०%", rank: "" },
            ],
          },
        ],
      },
      awards: {
        title: "पुरस्कार व मान्यता",
        sub: "शाळा व विद्यार्थ्यांच्या उल्लेखनीय कामगिरीचे क्षण.",
        items: [
          { year: "२०१५", text: "अनिल गीता सार्वजनिक विश्वस्त न्यास तर्फे कै. सौ. प्रतिभा लेले २०१५ आदर्श शिक्षिका पुरस्कार सौ. शीतल देशमुख यांना प्राप्त झाला." },
          { year: "२०१५", text: "राष्ट्र सेवा दल संचलित नाथ पै संस्कार केंद्र तर्फे घेण्यात आलेल्या बाल अभिनय स्पर्धेत प्रथम क्रमांकाचे पारितोषिक मिळाले." },
          { year: "२०१८", text: "सरस्वती विद्यामंदिर, कर्वेनगर आयोजित बालनाट्य भजन स्पर्धेत उत्तेजनार्थ पारितोषिक प्राप्त झाले." },
          { year: "२०१९", text: "महाराष्ट्र विद्या मंडळ तर्फे घेण्यात आलेल्या वेशभूषा स्पर्धेत दुसऱ्या क्रमांकाचे बक्षीस मिळाले." },
          { year: "२०१९", text: "ग्लोबल स्टार फाउंडेशन वेशभूषा स्पर्धेत विद्यार्थ्यांनी गोल्ड मेडल मिळविले." },
          { year: "—", text: "शारदा बालक विहार तर्फे घेण्यात आलेल्या बाल अभिनय स्पर्धेत शुभांगी पासलकर या शिक्षिकेला प्रथम क्रमांकाचे बक्षीस मिळाले व शाळेला फिरती ढाल प्राप्त झाली." },
          { year: "—", text: "धनंजय धडपळे परिवारातर्फे आयोजित वाहन पुस्तिका तयार करणे स्पर्धेत शाळेला उत्तेजनार्थ पुरस्कार प्राप्त झाला." },
        ],
      },
    },
  },

  en: {
    schoolName: "Vanaz Parivar Vidya Mandir",
    schoolOrg: "Vanaz Parivar Shikshan Mandal",
    schoolTagline: "Kothrud, Pune — Established 1978",
    vision: "Holistic development of students... is our only mission!",

    nav: {
      home: "Home",
      about: "About Us",
      facilities: "Facilities",
      activities: "Activities",
      gallery: "Gallery",
      achievements: "Achievements",
      contact: "Contact",
      enquire: "Admission Enquiry",
    },

    hero: {
      eyebrow: "Pre-Primary to Std. 10 | Marathi Medium | Established 1978",
      headlineA: "Your child's",
      headlineB: "bright future",
      headlineC: "begins with our trust",
      sub: "A trusted name in Kothrud for decades — delivering quality education, strong values, and holistic development to thousands of families.",
      ctaPrimary: "Enquire for Admission",
      ctaSecondary: "Visit the School",
      statYears: "Years of Legacy",
      statStudents: "Students & Alumni",
      statResult: "10th Board Result",
    },

    trust: {
      eyebrow: "Our Strengths",
      title: "Why parents trust us",
      sub: "Everything a parent wants — already built into our foundation.",
      items: [
        { title: "Experienced Teachers", desc: "Trained, dedicated, and deeply invested in each child's growth." },
        { title: "Safe Campus", desc: "CCTV surveillance, trained security and safe transport." },
        { title: "Excellent Results", desc: "Consistent top-tier 10th board results year after year." },
        { title: "Values & Discipline", desc: "Rooted in Marathi culture, character building and life skills." },
        { title: "Holistic Development", desc: "Academics, sports, arts, leadership — all in one place." },
      ],
    },

    aboutPrev: {
      eyebrow: "About Us",
      title: "A temple of knowledge, values and joy",
      p1: "Vanaz Parivar Vidya Mandir is a well-established educational institution in Kothrud, Pune, founded in 1978. We offer quality education from Pre-Primary to Std. 10 in Marathi medium.",
      p2: "We blend academic excellence, traditional values and a modern outlook. Every child is unique — our mission is to nurture what is best within them.",
      readMore: "Read More",
    },

    facPrev: {
      eyebrow: "Our Facilities",
      title: "Environments that nurture learning",
      sub: "Modern facilities and a safe campus — where learning is a joy.",
      items: [
        { title: "Smart Classrooms", desc: "Digital boards and projectors." },
        { title: "Rich Library", desc: "Extensive Marathi & English collection." },
        { title: "Computer Lab", desc: "Modern computers with internet." },
        { title: "Spacious Playground", desc: "Safe and ample space to play." },
        { title: "Security Systems", desc: "CCTV, guards, safe entry." },
        { title: "Hygiene & Health", desc: "Clean water and restrooms." },
      ],
    },

    actPrev: {
      eyebrow: "Our Activities",
      title: "Experiences beyond textbooks",
      sub: "A wide range of sports, arts, cultural and leadership activities.",
      items: [
        { title: "Sports Competitions", desc: "District and state level participation." },
        { title: "Cultural Programs", desc: "Ganeshotsav, annual day and festivals." },
        { title: "Science Projects", desc: "Exhibitions and innovations." },
        { title: "Leadership", desc: "Student council, Scouts, NCC." },
      ],
    },

    achPrev: {
      eyebrow: "Student Achievements",
      title: "A legacy of excellence, every year",
      sub: "Our students shine in academics, sports and arts — year after year.",
      stats: [
        { num: "91%", label: "10th Topper (2026)" },
        { num: "15+", label: "Merit Holders" },
        { num: "7+", label: "Awards & Recognitions" },
        { num: "46+", label: "Years of Legacy" },
      ],
      toppers: [
        { name: "Ms. Swara Arun Dhamale", marks: "91.00%", note: "1st Rank — 2026" },
        { name: "Ms. Khushi Navnath Tidke", marks: "90.60%", note: "2nd Rank — 2026" },
        { name: "Ms. Shreya Sameer Rawade", marks: "89.00%", note: "3rd Rank — 2026" },
      ],
    },

    testimonials: {
      eyebrow: "Parents Say",
      title: "In parents' own words",
      list: [
        { quote: "This school transformed my daughter's life. Teachers here impart not just education but also values.", author: "Sonal Gaikwad", role: "Parent — Std. 8" },
        { quote: "A safe, disciplined and joyful environment. The personal attention from teachers is our biggest comfort.", author: "Santosh Satpute", role: "Parent — Std. 10" },
        { quote: "We are proud that our son studies at Vanaz Parivar. Quality education at reasonable fees.", author: "Sonali Oswal", role: "Parent — Std. 5" },
      ],
    },

    enquiry: {
      eyebrow: "Admission Process",
      title: "Your child's bright future starts right here",
      sub: "Fill in the details — we'll reach out on WhatsApp instantly.",
      parentName: "Parent's Name",
      mobile: "Mobile Number",
      studentName: "Student's Name",
      standard: "Standard",
      selectStd: "Select Standard",
      submit: "Send on WhatsApp",
      success: "Thank you! You are being redirected to WhatsApp...",
      validation: "Please fill all the fields",
    },

    faq: {
      eyebrow: "Common Questions",
      title: "Frequently asked questions",
      items: [
        { q: "What are the school fees?", a: "Our fees are modest compared to other schools. Please visit the school or call us for details." },
        { q: "When do admissions open?", a: "Admissions open in January-February each year. Enquire now to reserve a seat." },
        { q: "What is the medium of instruction?", a: "Marathi medium is offered from Pre-Primary to Std. 10." },
        { q: "What are the school timings?", a: "Morning: 7:30 AM – 12:30 PM | Afternoon: 12:30 PM – 5:30 PM. Half day on Saturday." },
        { q: "Is school transport available?", a: "Yes — safe school bus service available across Kothrud and nearby areas." },
      ],
    },

    footer: {
      about: "A trusted school in Kothrud, Pune — a centre of academic quality, values and holistic development.",
      quickLinks: "Quick Links",
      contact: "Contact",
      followUs: "Follow Us",
      rights: "All rights reserved",
      downloadBrochure: "Download Brochure",
    },

    contactPg: {
      eyebrow: "Get in Touch",
      title: "We welcome your questions",
      sub: "Visit, call or message us on WhatsApp — we respond promptly.",
      address: "Address",
      addressVal: "Vanaz Parivar Shikshan Mandal, Kothrud, Pune - 411038, Maharashtra",
      phone: "Phone",
      email: "Email",
      hours: "Office Hours",
      hoursVal: "Monday to Saturday: 8:00 AM to 5:00 PM",
      getDirections: "Get Directions",
      whatsappNow: "Message on WhatsApp",
    },

    aboutPg: {
      title: "About Us",
      schoolInfo: {
        title: "School Information",
        items: [
          { label: "Organisation", value: "Vanaz Parivar Shikshan Mandal" },
          { label: "School Name", value: "Vanaz Parivar Vidya Mandir" },
          { label: "Address", value: "85/1, Paud Road, Vanaz Colony, Kothrud, Pune – 38" },
          { label: "Established", value: "1978" },
          { label: "Founder", value: "Shri. S. K. Khandekar Saheb" },
          { label: "Recognition No.", value: "VLS 1087/3261 Pra.Shi." },
          { label: "Type", value: "Recognised Private Aided School" },
          { label: "U-DISE Code", value: "27251401302" },
        ],
      },
      academic: {
        title: "Academic Structure",
        sub: "From pre-primary to Std. 10 — a coherent, child-centred curriculum.",
        divisions: [
          { title: "Pre-Primary (Balwadi)", items: ["Khelgat (Play Group)", "Shishugat (Nursery)", "Balgat (KG)"] },
          { title: "Primary", items: ["Std. 1 to 5", "Std. 6 to 8"] },
          { title: "Secondary", items: ["Std. 9", "Std. 10"] },
        ],
      },
      history: {
        title: "Our Legacy",
        p1: "Vanaz Parivar Vidya Mandir was founded in 1978 in Kothrud, Pune by Shri. S. K. Khandekar Saheb. Since then we have delivered quality education to thousands of students.",
        p2: "A harmonious blend of traditional Marathi culture and modern teaching methods — that's what makes our school unique.",
      },
      mission: {
        title: "Our Mission",
        text: "To give every student academic excellence along with character, confidence and a sense of social responsibility — shaping good human beings.",
      },
      visionCard: {
        title: "Our Vision",
        text: "Holistic development through knowledge, values and joy — preparing students for the 21st century.",
      },
      values: {
        title: "Our Values",
        items: ["Truth & Integrity", "Discipline & Respect", "Hard Work & Perseverance", "Co-operation & Service", "Humility & Gratitude"],
      },
      leadership: {
        title: "Board of Directors",
        sub: "Experienced, committed and passionate about education.",
        members: [
          { name: "Late Shri. S. K. Khandekar Saheb", role: "Founder" },
          { name: "Shri. Nitin Kulkarni", role: "President" },
          { name: "Smt. Rajnitai Date", role: "Vice President" },
          { name: "Shri. Y. K. Kadam", role: "Secretary" },
          { name: "Shri. Vinod Sakpal", role: "Treasurer" },
          { name: "Shri. A. L. Deshmukh", role: "Member" },
          { name: "Shri. P. R. Kulkarni", role: "Member" },
          { name: "Shri. S. J. Vispute", role: "Member" },
          { name: "Shri. Ajay Mohol", role: "Advisor" },
        ],
      },
      principals: {
        title: "Our Principals",
        sub: "Leadership across the three divisions — dedicated and experienced.",
        list: [
          { name: "Mrs. Sheetal Prashant Deshmukh", role: "Principal", qual: "M.A. Marathi, Balwadi Course", dept: "Pre-Primary Section" },
          { name: "Mrs. Anita Suryakant Darwatkar", role: "Principal", qual: "B.A., D.Ed.", dept: "Primary Section" },
          { name: "Mrs. Vrushali Bhushan Vashimkar", role: "Principal", qual: "M.A., B.Ed., D.S.M.", dept: "Secondary Section" },
        ],
      },
    },

    facilitiesPg: {
      title: "Our Facilities",
      sub: "A modern, safe campus — a perfect environment for learning.",
      list: [
        { title: "Smart Classrooms", desc: "Digital boards, projectors and airy rooms make learning engaging." },
        { title: "Library", desc: "Over 5,000 Marathi and English books — stories, references, biographies, exam prep." },
        { title: "Computer Lab", desc: "30 modern computers with high-speed internet and trained faculty." },
        { title: "Science Lab", desc: "Separate labs for Physics, Chemistry and Biology for hands-on learning." },
        { title: "Spacious Playground", desc: "Safe ground for cricket, kho-kho, kabaddi, badminton and volleyball." },
        { title: "CCTV Security", desc: "24x7 CCTV, trained guards, secure entry and visitor log." },
        { title: "Medical Room", desc: "First aid kit and registered medical help for emergencies." },
        { title: "Pure Drinking Water", desc: "RO + UV purified water with routine tank cleaning." },
        { title: "Clean Washrooms", desc: "Separate, clean, hygienic washrooms for boys and girls." },
      ],
    },

    activitiesPg: {
      title: "Our Activities",
      sub: "Beyond academics — we develop the whole personality.",
      categories: [
        { title: "Sports", items: ["Inter-school Cricket, Kho-Kho, Kabaddi", "Daily Yoga & Surya Namaskar", "Annual Sports Meet", "District & State level participation"] },
        { title: "Cultural", items: ["Ganeshotsav, Gudi Padwa, Independence Day", "Drama, dance, singing competitions", "Annual Day & prize distribution", "Marathi language preservation activities"] },
        { title: "Academic Competitions", items: ["Science exhibitions and innovations", "Essay, oratory, handwriting competitions", "Maths Olympiad & Scholarship prep", "MTSE, NTSE participation & mentoring"] },
        { title: "Social Initiatives", items: ["Tree plantation & eco awareness", "Cleanliness drives", "Visits to old-age and orphan homes", "Blood donation camps"] },
        { title: "Character Building", items: ["Moral education periods", "Leadership workshops", "Meditation & communication sessions", "Mentorship by elders"] },
      ],
    },

    // Gallery Page
    galleryPg: {
      title: "Gallery",
      sub: "A glimpse into the vibrant life, activities and spirit of our school.",
      filterAll: "All",
      categories: [
        { key: "purv", title: "Pre-Primary", caption: "The lively world of our youngest learners — play, songs, and the joy of learning." },
        { key: "prathmik", title: "Primary", caption: "Academic and co-curricular moments from our Std. 1 to 8 students." },
        { key: "madhyamik", title: "Secondary", caption: "Achievements, competitions and key milestones of Std. 9 and 10." },
      ],
    },

    achievementsPg: {
      title: "Student Achievements",
      sub: "The success of our students is our true reward.",
      toppers: {
        title: "Our Pride — Merit Holders",
        sub: "Our shining stars from the Std. 10 board exams.",
        years: [
          {
            year: "2026",
            list: [
              { name: "Ms. Swara Arun Dhamale", marks: "91.00%", rank: "1st Rank" },
              { name: "Ms. Khushi Navnath Tidke", marks: "90.60%", rank: "2nd Rank" },
              { name: "Ms. Shreya Sameer Rawade", marks: "89.00%", rank: "3rd Rank" },
            ],
          },
          {
            year: "2025",
            list: [
              { name: "Ms. Anushka Sameer Rawade", marks: "91.40%", rank: "" },
              { name: "Mr. Om Sangram Mule", marks: "90.80%", rank: "" },
              { name: "Ms. Bhakti Datta Shinde", marks: "90.20%", rank: "" },
            ],
          },
        ],
      },
      awards: {
        title: "Awards & Recognitions",
        sub: "Notable moments of pride for the school and our students.",
        items: [
          { year: "2015", text: "Mrs. Sheetal Deshmukh received the Late Mrs. Pratibha Lele 2015 Adarsh Shikshika Award from Anil Geeta Sarvajanik Vishwasta Nyas." },
          { year: "2015", text: "1st prize in the Bal Abhinay competition organised by Nath Pai Sanskar Kendra (Rashtra Seva Dal)." },
          { year: "2018", text: "Encouragement prize at the Balnatya–Bhajan competition hosted by Saraswati Vidya Mandir, Karvenagar." },
          { year: "2019", text: "2nd prize at the Costume Design (Veshbhusha) competition organised by Maharashtra Vidya Mandal." },
          { year: "2019", text: "Gold Medal won by students in the Global Star Foundation Veshbhusha competition." },
          { year: "—", text: "Teacher Mrs. Shubhangi Pasalkar won 1st prize in the Bal Abhinay competition by Sharda Balak Vihar; school received the rolling shield." },
          { year: "—", text: "School received an encouragement award in the Vahan Pustika Tayar Karne competition organised by Dhananjay Dhadpale Parivar." },
        ],
      },
    },
  },
};

export const standards = ["इयत्ता १ ली", "इयत्ता २ री", "इयत्ता ३ री", "इयत्ता ४ थी", "इयत्ता ५ वी", "इयत्ता ६ वी", "इयत्ता ७ वी", "इयत्ता ८ वी", "इयत्ता ९ वी", "इयत्ता १० वी"];
export const standardsEn = ["Std. 1", "Std. 2", "Std. 3", "Std. 4", "Std. 5", "Std. 6", "Std. 7", "Std. 8", "Std. 9", "Std. 10"];

// WhatsApp / Contact config
export const CONTACT = {
  phone: "+९१-९९२१५४२४०० / +९१-९९४६६६२४३२",
  phoneEn: "+91-9921542400 / +91-9946662432",
  phonePrimary: "+९१-९९२१५४२४००",
  phonePrimaryEn: "+91-9921542400",
  phoneSecondary: "+९१-९९४६६६२४३२",
  phoneSecondaryEn: "+91-9946662432",
  phoneRaw: "919921542400",
  phoneRawSecondary: "919946662432",
  whatsapp: "919921542400",
  email: "info@vanazparivar.edu.in",
  addressEn: "85/1, Paud Road, Vanaz Colony, Kothrud, Pune - 411038",
  addressMr: "८५/१, पौड रोड, वनाझ कॉलनी, कोथरूड, पुणे – ४११०३८",
  mapQuery: "Vanaz Colony Paud Road Kothrud Pune 411038",
};
